<template>
  <v-container>
    <v-row>
      <v-col cols="12">

        <v-card-text class="pa-0">

          <v-row v-if="alumno">
            <v-col cols="12" class="pa-0">
              <v-card-text>
                <b>Reporte generado por:</b> {{ getdatosUsuarioERPERP.nombre_completo }}
                <br/>
                <b>Matricula:</b> {{ alumno.matricula }}
                <br/>
                <b>Nombre:</b>    {{ alumno.alumno }}
                <br/>
                <v-chip label color="green" dark>
                  <b>Tipo de reporte: </b> Cambio de grupo
                </v-chip>
                <br/>
                <br/>
                <v-divider></v-divider>
                <v-row>

                  <!-- Grupo Anterior o grupo actual -->
                  <v-col cols="12" md="6" >
                    <v-tooltip bottom color="blue" max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-autocomplete
                          class="mt-2"
                          filled
                          dense
                          clearable
                          v-model="grupoAnterior"
                          :items="grupoAlumnos"
                          label="Grupo actual"
                          persistent-hint
                          prepend-inner-icon="mdi-clipboard-outline"
                          return-object
                          item-text="grupo"
                          item-value="id_grupo"
                          v-bind="attrs"
                          v-on="on"
                        >
                        </v-autocomplete>
                      </template>
                      <span>Selecciona el grupo actual del alumno</span>
                    </v-tooltip>

                    <v-card outlined class="pa-2" height="65">
                      <label v-if="grupoAnterior"><b>{{ grupoAnterior.grupo }}</b></label>
                    </v-card>
                    <br/>

                    <div v-if="grupoAnterior" class="mb-10">
                      <v-row>
                        <v-col cols="6" class="text-right pb-0">
                          <b>Costo curso:</b>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          {{ grupoAnterior.precio_grupo }}
                        </v-col>

                        <v-col cols="6" class="text-right pb-0">
                          <b>Pagado:</b>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          {{ grupoAnterior.pagado }}
                        </v-col>

                        <v-col cols="6" class="text-right pb-0">
                          <b>Becado:</b>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          {{ grupoAnterior.idbecas > 0 ? 'SI' : 'NO' }}
                        </v-col>

                        <v-col cols="6" class="text-right pb-0" v-if="alumno.idhermanos">
                          <b>Descuento Hermanos:</b>
                        </v-col>
                        <v-col cols="6" class="pb-0" v-if="alumno.idhermanos">
                          {{ alumno.idhermanos ? 'SI' : 'NO' }}
                        </v-col>

                        <v-col cols="6" class="text-right pb-0" v-if="esNI">
                          <b>ES NI:</b>
                        </v-col>
                        <v-col cols="6" class="pb-0" v-if="esNI">
                          SI
                        </v-col>

                        <v-col cols="6" class="text-right pb-0" v-if="dejoVenir">
                          <b>Dejó de venir:</b>
                        </v-col>
                        <v-col cols="6" class="pb-0" v-if="dejoVenir">
                          SI (tarifa actual)
                        </v-col>

                        <v-col cols="12">
                          <b>Concentrado de cambios</b>
                          <br/>
                          <p
                            style="white-space: pre-line"
                          >
                            {{ textoCambio }}
                          </p>

                        </v-col>


                      </v-row>
                    </div>
                  </v-col>

                  <v-col cols="12" md="6" >
                    <v-tooltip bottom color="blue" max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-autocomplete
                          class="mt-2"
                          filled
                          dense
                          clearable
                          v-model="nuevoGrupo"
                          :items="gruposDisponibles"
                          label="Nuevo Grupo"
                          persistent-hint
                          prepend-inner-icon="mdi-clipboard-outline"
                          return-object
                          item-text="grupo"
                          item-value="id_grupo"
                          no-data-text="Sin grupos disponibles (ciclos ya ocupados por el alumno)"
                          v-bind="attrs"
                          v-on="on"
                        >
                        </v-autocomplete>
                      </template>
                      <span>Selecciona el nuevo grupo al que cambiarás al alumno</span>
                    </v-tooltip>

                    <v-card outlined class="pa-2" height="65">
                      <label v-if="nuevoGrupo"><b>{{ nuevoGrupo.grupo }}</b></label>
                    </v-card>

                    <br/>

                    <div v-if="nuevoGrupo" class="mb-10">
                      <v-row>

                        <!-- COSTO DEL CURSO -->
                        <v-col cols="6" class="text-right pb-0">
                          <b>Costo curso:</b>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          {{ costoCurso }}
                        </v-col>

                        <!-- TOTAL A PAGAR -->
                        <v-col cols="6" class="text-right pb-0">
                          <b>Total a pagar:</b>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          {{ total_a_pagar.toFixed( 2 ) }}
                        </v-col>

                        <!-- ADEUDO -->
                        <v-col cols="6" class="text-right pb-0" v-if="total_a_pagar > grupoAnterior.pagado">
                          <b>Adeudo:</b>
                        </v-col>
                        <v-col cols="6" class="pb-0 red--text"  v-if="total_a_pagar > grupoAnterior.pagado">
                          {{ ( total_a_pagar - grupoAnterior.pagado ).toFixed( 2 )  }}
                        </v-col>

                        <!-- SALDO A FAVOR -->
                        <v-col cols="6" class="text-right pb-0" v-if="grupoAnterior.pagado - total_a_pagar > 0">
                          <b>Saldo a Mover:</b>
                        </v-col>
                        <v-col cols="6" class="pb-0" v-if="(grupoAnterior.pagado - total_a_pagar.toFixed( 2 ) ) > 0">
                          {{ grupoAnterior.pagado - total_a_pagar.toFixed( 2 ) }}
                        </v-col>

                        <v-col cols="12" class="pb-0">
                          <v-autocomplete
                            v-model="precioSeleccionado"
                            :items="precios"
                            @change="getPrecioPagar"
                            item-text="curso"
                            item-value="id_curso"
                            filled
                            dense
                            readonly
                          ></v-autocomplete>
                        </v-col>


                        <v-tooltip bottom color="blue" max-width="300" v-if="(grupoAnterior.pagado - total_a_pagar.toFixed( 2 ) ) > 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-autocomplete
                              class="mt-2"
                              filled
                              dense
                              clearable
                              v-model="id_grupo_favor"
                              :items="filterGruposSaldo"
                              label="Grupo a mandar el saldo a favor"
                              persistent-hint
                              prepend-inner-icon="mdi-clipboard-outline"
                              item-text="grupo"
                              item-value="id_grupo"
                              v-bind="attrs"
                              v-on="on"
                            >
                            </v-autocomplete>
                          </template>
                          <span>Selecciona grupo donde se aplicará el saldo a favor</span>
                        </v-tooltip>


                        <v-col cols="12">
                          <v-tooltip bottom color="blue" max-width="300">
                            <template v-slot:activator="{ on, attrs }">
                              <v-textarea
                                label="Por favor, ingresa el motivo de tu solicitud"
                                v-model="motivo"
                                filled
                                v-bind="attrs"
                                v-on="on"
                              ></v-textarea>
                            </template>
                            <span>Describe el motivo por el cual solicitas el cambio</span>
                          </v-tooltip>

                          <v-tooltip bottom color="blue" max-width="300">
                            <template v-slot:activator="{ on, attrs }">
                              <v-file-input
                                small-chips
                                multiple
                                filled
                                v-model="files"
                                accept="image/png, image/jpeg, image/bmp"
                                placeholder="Selecciona tus imagenes" prepend-icon="mdi-camera" label="Evidencias" @change="cargarFotos()"
                                v-bind="attrs"
                                v-on="on">
                              </v-file-input>
                            </template>
                            <span>Adjunta imágenes de evidencia o soporte</span>
                          </v-tooltip>

                          <v-row v-if="vistaPrevias.length">
                            <v-col cols="12" md="6" v-for="(img, i) in vistaPrevias" :key="i">
                              <v-card class="py-4 shadowCard">
                                <v-img :src="img.url" contain aspect-ratio="2"></v-img>
                                <v-tooltip bottom color="blue" max-width="300">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn  color="error"  small  @click="eliminarFoto(img.url)" top right absolute fab v-bind="attrs" v-on="on">
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Eliminar esta imagen</span>
                                </v-tooltip>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>

                    <div v-if="cambios">
                      <v-alert
                        dense
                        outlined
                        type="error"
                      >
                        Hola, han pasado <b>{{ cambios.dias_transcurridos }} días</b> desde que inicio el ciclo, para este cambio se requiere un pago de cambio de grupo, <b>FAVOR DE SELECCIONAR UN PAGO</b>
                      </v-alert>
                    </div>

                    <div v-if="cambios">
                      <v-data-table
                        :headers="headersMovimientos"
                        :items="movimientos"
                        class="elevation-0"
                        :mobile-breakpoint="100"
                        dense
                        id="grupos"
                        item-class="clase_row"
                        single-select
                        v-model="selected"
                        item-key="id_ingreso"
                        show-select
                      >
                      </v-data-table>
                    </div>
                  </v-col>

                  <!-- Grupo a grupo -->
                  <v-col cols="12">
                    <b>Grupos consecutivos</b>
                    <br/>
                    <p
                      style="white-space: pre-line"
                    >
                      <v-alert
                        dense
                        outlined
                        border="left"
                        type="warning"
                      >
                        Los grupos a continuación se verán afectados, por favor, asegurate que la información sea correcta
                      </v-alert>
                      <v-data-table
                        dense
                        :headers="headers"
                        :items="gruposConsecutivos"
                      >
                        <template v-slot:item.nuevo_grupo="{ item }">
                          <v-autocomplete
                            v-if="puedeSeleccionarGrupoConsecutivo()"
                            :key="'gc-' + item.id_grupo"
                            :value="grupoConsecutivoSeleccionado(item)"
                            @change="onGrupoConsecutivoChange(item, $event)"
                            :items="gruposDisponiblesConsecutivo(item)"
                            item-text="grupo"
                            return-object
                            dense
                            filled
                            hide-details
                            clearable
                            placeholder="Seleccionar grupo"
                            no-data-text="Sin grupos disponibles"
                            :menu-props="{ maxHeight: 320 }"
                          />
                          <v-chip v-else small label color="red" dark>
                            SIN GRUPO
                          </v-chip>
                        </template>
                        <template v-slot:item.pagado="{ item }">
                          {{ Number(item.pagado || 0).toFixed(2) }}
                        </template>
                        <template v-slot:item.saldo="{ item }">
                          <span :class="Number(item.saldo) < 0 ? 'red--text font-weight-bold' : ''">
                            {{ item.saldo }}
                          </span>
                        </template>
                      </v-data-table>

                    </p>
                  </v-col>
                </v-row>

                <br/>


                <v-alert
                  dense
                  border="left"
                  type="warning"
                  class="mt-2"
                >
                  Recuerda que al hacer un  <strong>CAMBIO</strong> de grupo, al alumno se le  <strong>BORRARÁN</strong> los datos, como lo son: <strong>ASISTENCIAS, EJERCICIOS y EXÁMENES</strong>
                </v-alert>
              </v-card-text>

              <v-card-actions v-if="tieneSaldo">
                <v-spacer></v-spacer>
                <v-tooltip bottom color="blue" max-width="300" v-if="nuevoGrupo && grupoAnterior && motivo || id_grupo_favor > 0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="green"
                      dark
                      tile
                      @click="confirmacion.estatus = true"
                      :loading="loading"
                      :disabled="disabled"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small left>mdi-send</v-icon>
                      Enviar solicitud
                    </v-btn>
                  </template>
                  <span>Enviar solicitud de cambio de grupo</span>
                </v-tooltip>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card-text>
      </v-col>
    </v-row>

    <dialogConfirmacion
      v-if="confirmacion.estatus"
      :confirmacion="confirmacion"
      @addCambio="addCambio"
    />

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
import axios from 'axios';
  var moment = require('moment');
  moment.locale();
  import XLSX from 'xlsx'
  import { mapGetters } from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';


  import dialogConfirmacion    from '@/components/cambios/dialogConfirmacion.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'
  import gruposConsecutivosMixin from '@/mixins/gruposConsecutivos'

  export default {

    components:{
      Alerta,
      carga,
      dialogConfirmacion
    },

    mixins: [ validarErrores, funcionesExcel, gruposConsecutivosMixin ],

    props: ['alumno','reporteTexto','tipo_reporte'],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      search: '',

      tipociclo:'',
      grupos:[],
      nuevoGrupo:null,
      tipocambios:[],
      tipoCambio:null,
      alumnos:[],

      grupoAlumnos:   [],
      grupoAnterior:  null,

      loading:        false,
      disabled:       false,
      motivo:         null,

      total_a_pagar: 0,
      precios:[],
      precioSeleccionado: null,

      dataGrupoActual: null,
      dataNuevoGrupo:null,
      precioSeleccionado2: null,
      descuentoHermanos:0,

      url:'',

      fotos:[],
      files: [],
      vistaPrevias:[],

      textoCambio: "",

      costoCurso: 0,
      id_grupo_favor:0,
      confirmacion: {
        estatus: false
      },
      gruposConsecutivos:[],

      anioMatricula: null,

      headers: [
        { text: 'Grupo '     , value: 'grupo'       },
        { text: 'Nuevo Grupo', value: 'nuevo_grupo' },
        { text: 'pagado'     , value: 'pagado'      },
        { text: 'Saldo'      , value: 'saldo'       },
      ],

      movimientos: [],

      cambios: false,

      selected:[],


      headersMovimientos: [
        { text: 'Folio'         , value: 'id_ingreso'      },
        { text: 'Grupo'         , value: 'grupo'           },
        { text: 'Monto pagado'  , value: 'pagado'          },
      ],

      esNI: 0,
      calculoPrecioOk: false,
      dejoVenir: 0,
      usarTarifaActual: 0,
    }),

    watch:{
      grupoAnterior () {
        this.nuevoGrupo = null
        this.gruposConsecutivos = []
        this.cambios = false
        this.selected = []
        if(this.grupoAnterior){
          this.getNuevoGrupoAlumno ()
        }else{
          this.grupos = []
        }
      },

      nuevoGrupo(value) {
        if (!value) {
          this.gruposConsecutivos = []
          return
        }
        if (!this.esGrupoDisponible(value)) {
          this.nuevoGrupo = null
          this.validarErrorDirecto('El alumno ya está inscrito en ese grupo. Elige otro grupo.')
          return
        }
        this.calculoAnio( value )
      },

      dataNuevoGrupo( value ){
        this.precioSeleccionado = value ? value.id_curso : null
      },

      // precioSeleccionado( value ){
        // if( value ){ this.getPrecioPagar() }
      // },

      precioSeleccionado2( value ){
        if( value ){ this.getPrecioPagar2() }
      },

      total_a_pagar() {
        if (this.gruposConsecutivos && this.gruposConsecutivos.length) {
          this.recalcularSaldosConsecutivos()
        }
      },
    },

    async created () {

      if([1,2,3,4,5,6,17,19,21,22,23,24,25,26].includes( this.getdatosUsuarioERPERP.id_plantel ) ){
        this.tipociclo = `grupo NOT LIKE '%FE%'`
      }else{ this.tipociclo = `grupo LIKE '%FE%'` }

      // Cargar los cursos actuales
      await this.getCursos()

      await this.getGrupoUsuario( )

      await this.getTitpoCambios()
    },

    methods: {

      calculoAnio (value){
        if (!value || !value.grupo || !this.alumno) return

        this.anioMatricula = this.alumno.matricula.substr(0,4)
        const anioActual = String(new Date().getFullYear())

        if (["2022", "2023", "2024","2025","2026"].includes(this.anioMatricula)) {
          const grupo = value.grupo
          
          const escuela = grupo.match('FAST') ? 2 : 1

          // NI o dejó de venir → catálogo del año actual (no el de la matrícula)
          if( this.usarTarifaActual ){ this.anioMatricula = anioActual }

          let cursos = this.precios.filter( el => el.curso.match (this.anioMatricula))

          console.log( cursos.map((registro) => registro.curso) )

          let cursoPredeterminado = cursos.find(curso => {

            const esOnline   = curso.curso.includes('ONLINE')
            const esFast     = curso.curso.includes('FAST')
            const esTeens    = curso.curso.includes('TEENS')
            const esSabatino = curso.curso.includes('TEENS')

            if (grupo.includes('ONLINE')) {
              if (escuela === 1) {
                if (grupo.includes('TEENS')) {
                  return esOnline && !esFast && esTeens
                } else {
                  return esOnline && !esFast && !esTeens
                }
              } else {
                return esOnline && esFast
              }
            } else {
              if (escuela === 1) {
                if (grupo.includes('TEENS')) {
                  console.log('ES INBI; TEENS')

                  return !esOnline && curso.curso.includes('INBI') && esTeens
                } else {
                  console.log('ES INBI; ADULTOS')
                  return !esOnline && curso.curso.includes('INBI') && !esTeens
                }
              } else {
                return !esOnline && esFast
              }
            }
          })

          console.log( cursoPredeterminado )

          this.precioSeleccionado = cursoPredeterminado
            ? cursoPredeterminado.id_curso
            : this.alumno.id_curso
        } else {
          this.precioSeleccionado = this.alumno.id_curso
        }

        this.textoCambio = ''

        if (value && value.id_plantel != this.grupoAnterior.id_plantel) {
          this.textoCambio = 'Cambio de Plantel'
        }

        if (value && value.id_ciclo != this.grupoAnterior.id_ciclo) {
          this.textoCambio += `
          Cambio de Ciclo`
        }

        if (value && value.id_horario != this.grupoAnterior.id_horario) {
          this.textoCambio += `
          Cambio de Horario`
        }

        if (value && value.id_nivel != this.grupoAnterior.id_nivel) {
          this.textoCambio += `
          Cambio de Nivel`
        }

        if (value) {
          this.getPrecioPagar()
        }
      },

      getCursos( ){
        this.cargar = true
        this.precios = []
        this.$http.get("all.precios").then((response) => {
          this.cargar = false
          this.precios = response.data.filter( el => el.curso.split("-")[1].match("3") );
        }).catch((error) => {
          this.validarError(error);
        }).finally(() => {
          this.cargar = false;
        });
      },

      getTitpoCambios () {
        this.cargar = true
        return this.$http.get('cambios.tipo.cambio').then(response=>{
          this.tipocambios = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPrecioPagar( ) {
        this.total_a_pagar = 0

        const payload = {
          id_alumno  : this.alumno.id_alumno,
          id_grupo   : this.grupoAnterior.id_grupo,
          idhermanos : this.alumno.idhermanos,
          escuela    : this.alumno.grupo.match('FAST') ? 2 : 1,
          id_curso   : this.precioSeleccionado,
          id_ciclo   : this.nuevoGrupo.id_ciclo,
        }

        return this.$http.post('pago.grupo.nuevo.descuento', payload).then(response=>{

          this.esNI = response.data[0].es_NI
          this.dejoVenir = response.data[0].dejo_venir
          this.usarTarifaActual = response.data[0].usar_tarifa_actual

          const anioActual = String(new Date().getFullYear())
          if( this.usarTarifaActual && this.anioMatricula != anioActual){  this.calculoAnio( this.nuevoGrupo ); return }

          if( this.precioSeleccionado ){

            // Validamos si el grupo anterior tenía iba

            if( this.grupoAnterior.iva ){

              this.total_a_pagar = Number( response.data[0].precio_lista * 1.16 )

            }else{
              
              this.total_a_pagar = Number( response.data[0].precio_lista )

            }

            if( this.grupoAnterior.idbecas > 0 ){

              this.total_a_pagar = Number( this.grupoAnterior.pagado )

            }


            let existeCosto = this.precios.find( el => el.id_curso == this.precioSeleccionado )

            this.costoCurso = existeCosto ? existeCosto.precio_lista : 0
            this.calculoPrecioOk = true

          }else{

            this.costoCurso = 0
            this.calculoPrecioOk = false
            
          }

          this.descuentoHermanos  = response.data[0].descuentoHermanos

          this.getGruposConsecutivos( )

          this.cargar = false
        }).catch( error =>{
          this.calculoPrecioOk = false
          this.validarError( error.response && error.response.data ? error.response.data.message : 'Error al calcular precio' )
        }).finally( () => { this.cargar = false })
      },


      getGruposConsecutivos( ){

        const payload = {
          id_alumno:   this.alumno.id_alumno,
          grupoActual: this.grupoAnterior.id_grupo,
          nuevoGrupo:  this.nuevoGrupo,
          total_a_pagar: this.total_a_pagar,
          id_curso: this.precioSeleccionado,
          id_grupo_actual: this.grupoAnterior.id_grupo,
          aplica_iva: !!this.grupoAnterior.iva,
        }

        return this.$http.post('grupos.consecutivos', payload).then(response=>{
          this.aplicarSaldosConsecutivosDesdeApi(response.data)
          this.cargar = false
        }).catch( error =>{
          const mensaje = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No fue posible cargar los grupos consecutivos'
          if (!String(mensaje).includes('No space left on device')) {
            this.validarError( mensaje )
          }
        }).finally( () => { this.cargar = false })
      },



      getPrecioPagar2( ) {

        const payload = {
          id_alumno: this.alumno.id_alumno,
          id_grupo:  this.dataGrupoActual.id_grupo,
          escuela:   this.dataNuevoGrupo.grupo.match('FAST') ? 2 : 1,
          id_curso:  this.dataGrupoActual.id_curso,
          id_ciclo:  this.dataNuevoGrupo.id_ciclo,
          alumno_ni: false
        }

        return this.$http.post('pago.grupo.nuevo.descuento', payload).then(response=>{

          this.total_a_pagar      = response.data[0].precio_lista
          this.descuentoHermanos  = response.data[0].descuentoHermanos

          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      async getNuevoGrupoAlumno() {

        // Rebotarlo en caso de no seleccionar un grupo
        if (!this.grupoAnterior) return;

        this.cargar = true; // iniciar el loader

        try {

          // Verificar la escuela
          const esFast = this.alumno.grupo.includes('FAST');
          const tipociclo = esFast ? `grupo LIKE '%FE%'` : `grupo NOT LIKE '%FE%'`;

          // Construir los parametros a enviar
          const payload = {
            tipociclo,
            id_ciclo: this.grupoAnterior.id_ciclo
          };

          const { data } = await this.$http.post('cambios.nuevo.grupos.ciclo', payload);

          this.cambios = data.cambios;
          this.grupos  = data.data;

          // validar si debe seleccionar un pago
          if( this.cambios ){ this.getMovimientos( ) }

        } catch (error) {

          const message = error.data.message;
          this.validarError(message);

        } finally {
          this.cargar = false;
        }

      },

      async getMovimientos ( ) {
        try{

          this.cargar = true; // iniciar el loader

          const { data } = await this.$http.get('inscripciones.alumno.grupos.activos/' + this.alumno.id_alumno);

          this.movimientos = data.filter( el => el.grupo.includes('CAMBIO'))

        } catch (error) {

          const message = error.data.message;
          this.validarError(message);

        } finally {
          this.cargar = false;
        }
      },

      getGrupoUsuario ( ){
        this.cargar = true
        this.grupoAlumnos = []
        return this.$http.get('cambios.grupo.usuario/' + this.alumno.id_alumno).then(response=>{
          this.grupoAlumnos = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      esGrupoDisponible (grupo) {
        if (!grupo) return false
        const id = Number(grupo.id_grupo)
        if (!id) return false
        return this.idsGruposInscritosAlumno.indexOf(id) === -1
      },

      async addCambio () {

        // Validamos si es necesario primero lo del cambios
        if( this.cambios && !this.selected.length ){ this.validarErrorDirecto('Favor de seleccionar el folio de pago del cambio') }

        // Validamos si es necesario primero lo del cambios
        if( !this.motivo ){ this.validarErrorDirecto('Favor de agregar un motivo') }

        // Validamos si hay evidencias
        if( !this.vistaPrevias.length ){ this.validarErrorDirecto('Favor de agregar una evidencia para la solicutd') }

        if (this.nuevoGrupo && !this.esGrupoDisponible(this.nuevoGrupo)) {
          return this.validarErrorDirecto('El alumno ya está inscrito en ese grupo. Elige otro grupo.')
        }

        // Validar que esten llenos los campos
        if (!this.calculoPrecioOk || !this.precioSeleccionado) {
          return this.validarErrorDirecto('No se pudo calcular el precio. Revisa el grupo nuevo o vuelve a intentarlo.')
        }

        if(this.nuevoGrupo && this.grupoAnterior && this.motivo ){

          this.cargar = true

          let fotos = []
          if(this.vistaPrevias.length){
            let respuesta = await this.subirFotosServidor( )
            fotos = respuesta.data
          }

          // Activar el disabled del boton para que no le den doble click
          // this.loading  = true
          // this.disabled = true
          // Desesestructuración de alumno
          const { id_alumno, id_plantel, monto_pagado_total } = this.alumno

          // Generar el payload a mandar
          let payload = {
            id_alumno,
            idtipo_cambio:   0,
            solicito_cambio: this.getdatosUsuarioERPERP.iderp,
            id_plantel,
            id_grupo_actual: this.grupoAnterior.id_grupo,
            id_grupo_nuevo:  this.nuevoGrupo.id_grupo,
            estatus:         1,
            diferencia:      monto_pagado_total,
            motivo:          this.motivo,
            fotos,
            tipo_reporte       : this.tipo_reporte || 8,
            id_ingreso         : null,
            nuevo_comprobante  : null,
            viejo_metodo:      0,
            nuevo_metodo:      0,
            viejo_monto:       this.grupoAnterior.pagado || 0,
            nuevo_monto:       this.total_a_pagar || 0,
            id_curso_actual:   this.alumno.id_curso || 0,
            id_nuevo_curso:    this.precioSeleccionado || 0,
            vieja_fecha:       null,
            nueva_fecha:       null,
            textoCambio:       this.textoCambio,
            id_grupo_favor:    this.id_grupo_favor  ? this.id_grupo_favor : 0,
            id_ingreso_cambio: this.selected.length ? this.selected[0].id_ingreso : 0,
            pago_cambios:      this.cambios         ? 1 : 0
          }

          this.cargar = true

          // Enviar los datos
          this.$http.post('cambios.add',payload).then(response=>{

            this.validarSuccess( 'Datos grabados correctamente')

            this.$emit('getAlumnosxEscuela')

          }).catch(error=>{
            this.validarError( error.response.data.message )
          })
        }else{
          this.estatusError('Favor de ingresar el grupo y el tipo de cambio')
        }
      },

      subirFotosServidor( ){
        let formData = new FormData();

        for( const i in this.vistaPrevias ){
          formData.append('file', this.vistaPrevias[i].file )
        }

        return new Promise((resolve,reject)=>{
          // obtener la extensión del archivo
          // Hacemos la petición
          this.$http.post(`cambios.evidencia`, formData ).then(response=>{
            resolve( response )
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        })
      },

      cargarFotos(){
        if(this.files.length < 1){
          return
        }

        this.files.forEach((element, index) => {
                // creamos una variable tipo FormData
          let formData = new FormData();
                //se crea el objeto y se le agrega como un apendice el archivo
          formData.append('file', element);
                //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
          this.getBase64(element, formData)
        })
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          me.vistaPrevias.push({
            url: reader.result,
            formData: formData,
            image_name: file.name,
            file
          })
        };
      },

      eliminarFoto(value){
        this.vistaPrevias.forEach((element, index)=>{
          if(element.url == value){
            this.vistaPrevias.splice(index,1);
          }
        })
      },
    },

    computed:{
      ...mapGetters ('login',['getdatosUsuarioERPERP']),

      currentTitle () {
        switch (this.step) {
          case 1: return 'Selecciona el alumno'
          case 2: return 'Selecciona tipo de reporte'
          default: return 'Confirma tu reporte'
        }
      },

      // Grupos donde el alumno ya tiene registro (incluye el que está cambiando)
      idsGruposInscritosAlumno () {
        if (!this.grupoAlumnos || !this.grupoAlumnos.length) return []

        return [...new Set(
          this.grupoAlumnos
            .map((g) => Number(g.id_grupo))
            .filter((id) => id > 0)
        )]
      },

      // Permite mismo ciclo; solo oculta grupos donde YA está inscrito
      gruposDisponibles () {
        if (!this.grupos.length) return []

        const idsInscritos = this.idsGruposInscritosAlumno
        const seen = {}

        return this.grupos.filter((g) => {
          const id = Number(g.id_grupo)
          if (!id || seen[id]) return false
          seen[id] = true
          if (idsInscritos.indexOf(id) !== -1) return false
          return true
        })
      },

      filterGruposSaldo( ){

        const { id_ciclo } = this.nuevoGrupo

        return this.gruposDisponibles.filter( el => el.id_ciclo != id_ciclo )

      },

      tieneSaldo( ){

        if( this.grupoAnterior && ( (this.grupoAnterior.pagado - this.total_a_pagar.toFixed( 2 ) ) > 0 ) ){

          if( this.id_grupo_favor > 0 ){

            return true

          }else{

            return false

          }

        }else{

          return true

        }

      },

    }
  }
</script>

<style>

  .v-menu__content::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-menu__content::-webkit-scrollbar:vertical {
    width: 10px !important;
  }

  .v-menu__content::-webkit-scrollbar:vertical{
    width: 10px !important;
  }

  .v-menu__content::-webkit-scrollbar-button:increment,.v-menu__content::-webkit-scrollbar-button{
    display: none;
  }

  .v-menu__content::-webkit-scrollbar:horizontal{
    height: 10px !important;
  }

  .v-menu__content::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }
</style>
